import { IsoDate } from '../../../types/iso-date';

export function toIsoDate(date: Date): IsoDate {
  const svDate = new Intl.DateTimeFormat('sv-SE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour12: false,
  }).format(date);

  return `${svDate}` as IsoDate;
}
